import gsap from 'gsap';
import { SECTIONS_IDS } from 'constants/global';

export const heroAnimation = () => {
  gsap.from(['#hero-h1', '#hero-title', '#hero-subtitle'], {
    duration: 0.7,
    yPercent: 100,
    opacity: 0,
    autoAlpha: 0,
    stagger: 0.5,
    ease: 'sine.out',
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: `#${SECTIONS_IDS.hero}`,
      end: '+=500',
      scrub: true,
      pin: true,
      pinSpacing: 'padding',
      invalidateOnRefresh: true,
    },
  });

  tl.fromTo('#hero-h1', { yPercent: 0, opacity: 1 }, { yPercent: -50, opacity: 0 });
  tl.fromTo('#hero-title', { yPercent: 0, opacity: 1 }, { yPercent: -20, opacity: 0 });
  tl.fromTo('#hero-subtitle', { yPercent: 0, opacity: 1 }, { yPercent: -50, opacity: 0 });
};
